import { getFormattedPriceWithStripe, getFormattedPrice } from '@vakantiesnl/services/src/util/mathUtils';
import { type MicroCopy } from '@vakantiesnl/types';

export const getExtraPriceTitlePerPerson = (price: number): string => `+ ${getFormattedPriceWithStripe(price)} p.p`;

export const getExtraPriceTitle = (price: number): string => `+ ${getFormattedPriceWithStripe(price)}`;

export const getExtraPriceTitleWithDecimalsPerPerson = (price: number): string => `+ ${getFormattedPrice(price)} p.p`;

export const getExtraPriceTitleWithDecimals = (price: number): string => `+ ${getFormattedPrice(price)}`;

export const getLabelText = (isCheapest: boolean, microCopies: MicroCopy): string =>
	isCheapest ? microCopies['cheapestOption'] : microCopies['idealTrip'];
